//  const apiUrl = 'http://localhost:8090'
// const apiUrl = 'https://xichuang2.aitubu.online'
const apiUrl = 'https://xichuang2.xcswdz.top'
// const apiUrl = 'http://49.233.178.38:8080'
export default {
  apiUrl
}



// WEBPACK FOOTER //
// ./src/global/global.js